var _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 5,
    y: 2,
    width: 30,
    height: 30,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M82 83.6 62 64.6 82 45.6 82 83.6ZM17.2 86 37 67.3 38.4 66C43.8 60.9 52.3 60.9 57.7 66L59.1 67.3 78.8 86 17.2 86ZM14 45.5 34 64.5 14 83.5 14 45.5ZM28 20 68 20 68 53.3 59 61.9C52.5 56.9 43.5 56.9 37 61.9L28 53.3 28 20ZM74 22.7 74 14 60 14 48 4 36 14 22 14 22 22.8 8 36.1 8 92 88 92 88 36.1 74 22.7Z",
    stroke: "#000000",
    strokeWidth: 0.999905,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 42.3C46.2 42.3 44.8 40.8 44.8 39.1 44.8 37.3 46.3 35.9 48 35.9 49.8 35.9 51.2 37.3 51.2 39.1 51.2 40.9 49.8 42.3 48 42.3ZM48 52C50.3 52 52.5 51.4 54.5 50.4 55.3 49.9 55.6 48.9 55.2 48.1 54.7 47.3 53.7 47 52.9 47.4 51.4 48.2 49.7 48.6 48 48.6 42.7 48.6 38.3 44.2 38.4 38.9 38.4 33.6 42.8 29.2 48.1 29.2 53.4 29.2 57.8 33.5 57.8 38.9L57.8 42.1C56 42.1 54.6 40.7 54.6 38.9 54.6 35.7 52.4 33 49.3 32.4 46.2 31.8 43.1 33.5 42 36.4 40.9 39.3 42 42.7 44.7 44.3 47.4 45.9 50.9 45.4 53 43 54.2 44.4 56 45.2 57.9 45.2 59.7 45.2 61.1 43.8 61.1 42L61.1 38.8C61.1 31.6 55.3 25.8 48.1 25.8 40.9 25.8 35.1 31.6 35.1 38.8 35 46.1 40.8 51.9 48 52Z",
    stroke: "#000000",
    strokeWidth: 0.999905,
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c107094050b38adfa1f9304a355a1c47.svg";
export { ForwardRef as ReactComponent };